export default __webpack_public_path__ + "3638fb1f2a05218edea3ab21730d6994.png";